import { State } from '../types'

export const selectPendingReceivementsState = (state: State) => state.pendingReceivements
export const selectBadgeStatus = (state: State) => state.pendingReceivements.badgeStatus
export const selectLoading = (state: State) => state.pendingReceivements.loading
